<div
  [appStoryblok]="_editable"
  [ngClass]="{ 'pb-5': padding }"
  class="container-xl pt-3"
>
  <div class="row gx-0">
    <div [ngClass]="{ 'pb-lg-5': padding }" class="col-12 col-lg-10 display-1">
      {{ text }}
    </div>
  </div>
</div>
